import React from 'react';
import { Container, Table, Title } from './styled';
import { observer } from 'mobx-react';

const PitcherTable = observer(({ data }) => {
  return (
    <Container>
      <Title>투수</Title>
      <Table>
        <thead>
          <tr>
            <th>선수명</th>
            <th>승</th>
            <th>패</th>
            <th>세이브</th>
            <th>홀드</th>
            <th>평균자책</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            const {
              name,
              wins,
              losses,
              saves,
              holds,
              earnedRunAverage
            } = value;
            return (
              <tr key={key}>
                <td>{name}</td>
                <td>{wins}</td>
                <td>{losses}</td>
                <td>{saves}</td>
                <td>{holds}</td>
                <td>{earnedRunAverage}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
});

export default PitcherTable;
